import { combineReducers } from "redux";
import mainReducer from "@gc-npm/reducers.main-reducer";
import modalsReducer from "@gc-npm/reducers.modals-reducer";
import headerReducer from "@gc-npm/reducers.header-reducer";
import clientPersonalizationReducer from '@/reducers/client-personalization';

const REDUCERS_LIST = {
  main: mainReducer,
  modals: modalsReducer,
  header: headerReducer,
  clientPersonalization: clientPersonalizationReducer,
};

const rootReducers = () =>
  combineReducers({
    ...REDUCERS_LIST,
  });

export default rootReducers;
